export class UploadFileWrapper {

  id: string;
  soporte: any;

  constructor(
    id: string,
    soporte: any
  ) {
    this.id = id;
    this.soporte = soporte;
  }
}
